module.exports = __webpack_public_path__ + "static/img/img4.965e8dc8.png";